// @flow
import { FlexCol, Wrapper } from "./Popup.styles";
import { TextInputField } from "../LoginPassword/TextInput.jsx";
import { Toggle } from "../Toggle";
import { format, validate } from "rut.js";
import { useForm } from "react-hook-form";
import React, { useGlobal, useState } from "reactn";
import styled from "styled-components";
import theme, { getColor, getGradient, getSize } from "views/resources/theme";

interface Props {
	setUserRut(rut: string): void;
	setUserDni(dni: string): void;
	close(): void;
}

const RutPopup = ({ setUserRut, setUserDni, close }: Props) => {
	const [shouldSendDni, setShouldSendDni] = useState(false);
	const [loading, setLoading] = useState(false);
	const [inputs, setInputs] = useState({ rut: null, dni: null });
	const updateUser = () => {
		setLoading(true);
		if (!validate(format(inputs.rut)) && !shouldSendDni) {
			setLoading(false);
			alert("RUT inválido");
			return;
		}
		if (shouldSendDni) {
			setUserDni(inputs.dni)
				.then(() => {
					close();
					setLoading(false);
				})
				.catch((e) => {
					alert(e);
					setLoading(false);
				});
			return;
		}
		setUserRut(inputs.rut)
			.then(() => {
				close();
				setLoading(false);
			})
			.catch((e) => {
				alert(e);
				setLoading(false);
			});
	};

	const handleChange = ({ target: { name, value } }) =>
		setInputs({ ...inputs, [name]: value });

	return (
		<Wrapper>
			<FlexCol>
				<form>
					<h3>
						Por favor, ingresa el número de tu documento de
						identificación (RUT o DNI)
					</h3>
					<FlexCol>
						<Toggle
							label=""
							left="DNI"
							right="RUT"
							onChange={() => setShouldSendDni((p) => !p)}
						/>

						<TextInputField
							visible={!shouldSendDni}
							value={format(inputs["rut"])}
							name="rut"
							isValid={true}
							label="RUT"
							onChange={handleChange}
						/>

						<TextInputField
							visible={shouldSendDni}
							value={inputs["dni"]}
							name="dni"
							isValid={true}
							label="DNI"
							onChange={handleChange}
						/>

						<Button
							type="button"
							onClick={updateUser}
							disabled={loading}
						>
							{loading ? "Cargando..." : "Guardar"}
						</Button>
						<SecondaryButton onClick={() => close()}>
							Volver
						</SecondaryButton>
					</FlexCol>
				</form>
				{/*
				<div onClick={onClose} className="close">
					Acceso sin RUT
				</div>
				*/}
			</FlexCol>
		</Wrapper>
	);
};

// FIXME: Refactor. DRY
const Button = styled.button`
	border-radius: ${getSize("xs")};
	background: ${getGradient("blue")};
	color: ${getColor("fg_alt")};
	border: none;
	width: 100%;
	padding: ${getSize("m")} 0;
	margin: ${getSize("m")} 0;
	&:hover {
		cursor: pointer;
	}
`;

const SecondaryButton = styled.div`
	border-radius: ${getSize("xs")};
	border: 1px solid ${getColor("fg_alt")};
	width: 100%;
	padding: ${getSize("m")} 0;
	margin: ${getSize("m")} 0;
	&:hover {
		cursor: pointer;
	}
`;

const Input = styled.input`
	border: 1px solid ${(props) => props.borderColor};
	border-radius: ${getSize("xs")};
	padding: ${getSize("m")} 0;
	margin: ${getSize("m")} 0;
`;

export default RutPopup;
